import { ref } from 'vue';

// Reactive state to store the product count
const productCount = ref<number>(0);

// Cache threshold - only cache when we have this many or more products
const CACHE_THRESHOLD = 10;

/**
 * Updates the product count
 * @param count New product count
 */
function setProductCount(count: number): void {
  productCount.value = count;
}

/**
 * Gets the current product count
 * @returns The number of products
 */
function getProductCount(): number {
  return productCount.value;
}

/**
 * Checks if cache should be applied based on product count
 * @returns true if cache should be applied, false otherwise
 */
function shouldApplyCache(): boolean {
  return productCount.value >= CACHE_THRESHOLD;
}

/**
 * Clears the product count
 */
function clearProductData(): void {
  productCount.value = 0;
}

export default {
  setProductCount,
  shouldApplyCache,
  getProductCount,
  clearProductData,
  CACHE_THRESHOLD
};
